import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Grid,
} from "@mui/material";
import configServ from "../../services/config";

const CompalintCard = ({ isCreate, setIsCreate, isEdit, setIsEdit, editData, setEditData, isChanged, setIsChanged }) => {
  const { company_id, user_id, is_super, is_admin } = useSelector(
    (state) => state.GlobalVariables
  );

  const [formData, setFormData] = useState({
    customer_id: "",
    site_id: "",
    job_category_id: "",
    job_detail_id: "",
    title: "",
    description: "",
    status: "pending",
    supervisor_id: "",
    supervisor_remark: "",
  });

  const [customerList, setCustomerList] = useState([]);
  const [siteList, setSiteList] = useState([]);
  const [jobMasterList, setJobMasterList] = useState([]);

  // Fetch initial Master options
  useEffect(() => {
    if (company_id) {
      fetchCustomer();
      fetchJobMaster();
    }
  }, [company_id]);

  // Edit Mode state binding & site list fetching fix
  useEffect(() => {
    if (isEdit && editData) {
      setFormData({
        customer_id: editData.customer_id || "",
        site_id: editData.site_id || "",
        job_category_id: editData.job_category_id || "",
        job_detail_id: editData.job_detail_id || "",
        title: editData.title || "",
        description: editData.description || "",
        status: editData.status || "pending",
        supervisor_id: editData.supervisor_id || "",
        supervisor_remark: editData.supervisor_remark || "",
      });

      // Customer select tha to site list fetch karke dropdown fill karo
      if (editData.customer_id) {
        fetchShipToAddress(editData.customer_id);
      }
    } else {
      handleReset();
    }
  }, [isEdit, editData]);

  const jobDetailId = formData.job_detail_id || editData?.job_detail_id;
  const isJobAssigned = Boolean(
    isEdit &&
    jobDetailId !== null &&
    jobDetailId !== undefined &&
    jobDetailId !== "" &&
    jobDetailId !== "null" &&
    jobDetailId !== 0
  );

  const fetchCustomer = async () => {
    try {
      const res = await configServ.getSatandardActiveCustomer({ company_id });
      if (res?.status) setCustomerList(res.data || []);
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };

  const fetchShipToAddress = async (cust_id) => {
    try {
      const res = await configServ.getShipToAddress({ cust_id });
      setSiteList(res?.data || res || []);
    } catch (error) {
      console.error("Error fetching sites:", error);
    }
  };

  const fetchJobMaster = async () => {
    try {
      const res = await configServ.getactivejobMaster({ company_id });
      if (res?.status) setJobMasterList(res.data || []);
    } catch (error) {
      console.error("Error fetching job master:", error);
    }
  };

  const handleReset = () => {
    setFormData({
      customer_id: "",
      site_id: "",
      job_category_id: "",
      job_detail_id: "",
      title: "",
      description: "",
      status: "pending",
      supervisor_id: "",
      supervisor_remark: "",
    });
    setSiteList([]);
    if (setIsEdit) setIsEdit(false);
    if (setEditData) setEditData(null);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "customer_id") {
      setFormData((prev) => ({ ...prev, site_id: "" }));
      if (value) {
        fetchShipToAddress(value);
      } else {
        setSiteList([]);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const finalPayload = {
      ...(isEdit && editData?.id && { complaint_id: editData.id }), // Include ID on Update
      company_id: company_id,
      customer_id: formData.customer_id ? Number(formData.customer_id) : null,
      site_id: formData.site_id ? Number(formData.site_id) : null,
      job_category_id: formData.job_category_id ? Number(formData.job_category_id) : null,
      job_detail_id: formData.job_detail_id ? Number(formData.job_detail_id) : null,
      title: formData.title,
      description: formData.description,
      status: formData.status,
      supervisor_id: user_id || null,
      supervisor_remark: formData.supervisor_remark || null,
    };

    try {
      let res;
      if (isEdit) {
        // Update API Call
        res = await configServ.updateComplaint(finalPayload);
      } else {
        // Create API Call
        res = await configServ.postComplaint(finalPayload);
      }

      if (res?.status) {
        alert(isEdit ? "Complaint updated successfully!" : "Complaint submitted successfully!");
        handleReset();
        setIsCreate(false);
        setIsEdit(false);
        setIsChanged(!isChanged);
        setEditData({});

      } else {
        alert(res?.message || "Operation failed.");
      }
    } catch (error) {
      console.error("Error submitting complaint:", error);
      alert("An error occurred while submitting the complaint.");
    }
  };

  return (
    <Box sx={{ width: "100%", p: { xs: 1, sm: 2, md: 3 } }}>
      <Card elevation={3}>
        <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
          <Typography variant="h5" component="h2" gutterBottom align="left" sx={{ mb: 3 }}>
            {isEdit ? "Update Complaint" : "Create Complaint"}
          </Typography>

          <Box component="form" onSubmit={handleSubmit}>
            <Grid container spacing={2}>

              {/* Customer Select */}
              <Grid item xs={12} sm={6} md={6} lg={4}>
                <FormControl fullWidth required size="small" disabled={isJobAssigned}>
                  <InputLabel id="customer-label">Customer</InputLabel>
                  <Select
                    labelId="customer-label"
                    name="customer_id"
                    value={formData.customer_id}
                    label="Customer"
                    onChange={handleChange}
                    disabled={isJobAssigned}
                  >
                    <MenuItem value="">
                      <em>Select Customer</em>
                    </MenuItem>
                    {customerList?.map((cust) => (
                      <MenuItem key={cust.id} value={cust.id}>
                        {cust.name || cust.contact_name || `Customer #${cust.id}`}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {/* Site Select */}
              <Grid item xs={12} sm={6} md={6} lg={4}>
                <FormControl fullWidth size="small" disabled={!formData.customer_id || isJobAssigned}>
                  <InputLabel id="site-label">Site / Location</InputLabel>
                  <Select
                    labelId="site-label"
                    name="site_id"
                    value={formData.site_id}
                    label="Site / Location"
                    onChange={handleChange}
                    disabled={!formData.customer_id || isJobAssigned}
                  >
                    <MenuItem value="">
                      <em>Select Site</em>
                    </MenuItem>
                    {siteList?.map((site) => (
                      <MenuItem key={site.id} value={site.id}>
                        {site.site_name || site.address || `Site #${site.id}`}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {/* Job Category Select */}
              <Grid item xs={12} sm={6} md={6} lg={4}>
                <FormControl fullWidth size="small" disabled={!formData.customer_id || isJobAssigned}>
                  <InputLabel id="category-label">Job Category</InputLabel>
                  <Select
                    labelId="category-label"
                    name="job_category_id"
                    value={formData.job_category_id}
                    label="Job Category"
                    onChange={handleChange}
                    disabled={!formData.customer_id || isJobAssigned}

                  >
                    <MenuItem value="">
                      <em>Select Category</em>
                    </MenuItem>
                    {jobMasterList?.map((job) => (
                      <MenuItem key={job.id} value={job.id}>
                        {job.title || job.job_name || `Category #${job.id}`}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {/* Title Input */}
              <Grid item xs={12} sm={6} md={6} lg={8}>
                <TextField
                  fullWidth
                  required
                  size="small"
                  label="Title"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  disabled={isJobAssigned}
                />
              </Grid>

              {/* Status Select */}
              <Grid item xs={12} sm={6} md={6} lg={4}>
                <FormControl fullWidth size="small">
                  <InputLabel id="status-label">Status</InputLabel>
                  <Select
                    labelId="status-label"
                    name="status"
                    value={formData.status}
                    label="Status"
                    onChange={handleChange}
                  >
                    <MenuItem value="pending">Pending</MenuItem>
                    <MenuItem value="approved">Approved</MenuItem>
                    <MenuItem value="denied">Denied</MenuItem>
                    <MenuItem value="in_progress">In Progress</MenuItem>
                    <MenuItem value="closed">Closed</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {/* Description Input */}
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  required
                  multiline
                  rows={3}
                  size="small"
                  label="Description"
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  disabled={isJobAssigned}
                />
              </Grid>

              {/* Action Buttons Container */}
              <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 2 }}>
                {isEdit && (
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={handleReset}
                    sx={{ px: 3, py: 1 }}
                  >
                    Cancel
                  </Button>
                )}
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  sx={{ px: 4, py: 1 }}
                >
                  {isEdit ? "Update Complaint" : "Submit Complaint"}
                </Button>
              </Grid>

            </Grid>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default CompalintCard;